;(function () {
    function SampleOrderSuccess() {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * config
         */
        this.config = {}

        /**
         * Checks if the cart contains items otherwise the page has been reloaded
         * Resets cart and sets sample order in data layer
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.config = window.Creaton.Cart.Configuration

            var cart = JSON.parse(localStorage.getItem(_this.config.cart))

            if (!(cart === undefined) && !$.isEmptyObject(cart)) {
                var cartItems = localStorage.getItem(_this.config.cart)
                _this.emptyCart() // has to be done first
                _this.addSampleOrderToDataLayer(cartItems)// can be failed if window.datalayer is not accessible
            }
        }

        /**
         * Generates the sample order data and adds it to the data layer
         */
        this.addSampleOrderToDataLayer = function (cartItems) {
            var controller = new window.Creaton.OrderDataLayerController()
            var dataLayerObject = controller.generateDataLayerObjectFromCart(cartItems)
            window.dataLayer.push(dataLayerObject)
        }

        /**
         * Empties the cart by removing the object in local storage
         * and updating configuration and cart item counter
         */
        this.emptyCart = function () {
            _this.removeCartFromLocalStorage()
            _this.updateCartIconItemCounter()
        }

        /**
         *  Remove the current cart from the storage
         *  and update The configuration
         * @return {undefined}
         */
        this.removeCartFromLocalStorage = function () {
            localStorage.removeItem(_this.config.cart)
            _this.config.cartItems = JSON.parse(localStorage.getItem(_this.config.cart))
        }

        this.updateCartIconItemCounter = function () {
            _this.config.$cartHeaderIconCounter.empty()
            _this.config.$cartHeaderIcon.removeClass('btn-with-counter')
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Creaton = window.Creaton || {}

    window.Creaton.SampleOrderSuccess = SampleOrderSuccess
})()

$(document).ready(function () {
    if (
        window.location.search.includes('sampleOrderSuccess=true') ||
        $('[rel="sample-order-success-page"]').length > 0
    ) {
        new window.Creaton.SampleOrderSuccess()
    }
})
